<div class="card-head">
  <h2>Basket</h2>
  <div class="flex-fill"></div>
  <span class="count-tag" data-test="tx-detail-basket-count">
    {{ itemCount }} {{ itemCount === 1 ? 'item' : 'items' }}
  </span>
</div>

<div class="card-body">
  @if (isRichBasket) {
    <div class="bk-scroll">
      <table class="bk-table">
        <thead>
        <tr>
          <th>Item</th>
          <th class="num">Qty</th>
          <th class="num">Unit</th>
          <th class="num">Total</th>
        </tr>
        </thead>
        <tbody>
          @for (item of items; track item) {
            <tr>
              <td>
                <div class="bk-desc">{{ item.description }}</div>
                @if (item.sku) { <div class="bk-sku">{{ item.sku }}</div> }
              </td>
              <td class="num">{{ item.quantity || 1 }}</td>
              <td class="num" [attr.data-test]="'itemValue'">{{ unitPrice(item) | currency: currency }}</td>
              <td class="num">{{ lineTotal(item) | currency: currency }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="bk-simple">
      @for (item of items; track item) {
        <div class="bk-simple-row">
          <span class="bk-desc">
            @if (item.quantity && item.quantity > 1) { <span>{{ item.quantity }} × </span> }{{ item.description }}
          </span>
          <span class="amt" [attr.data-test]="'itemValue'">{{ lineTotal(item) | currency: currency }}</span>
        </div>
      }
    </div>
  }

  <div class="bk-totals">
    @if (isRichBasket) {
      <div class="bk-trow"><span>Subtotal</span><span class="amt">{{ subtotal | currency: currency }}</span></div>
    }
    @for (discount of discounts; track discount) {
      <div class="bk-trow neg">
        <span>{{ discount.description || discount.code }}@if (discount.rate) { <span>({{ discount.rate }})</span> }</span>
        <span class="amt" [attr.data-test]="'discountValue'">{{ discount.amount | currency: currency }}</span>
      </div>
    }
    @for (tax of taxes; track tax) {
      <div class="bk-trow">
        <span>{{ tax.description || tax.code }}@if (tax.rate) { <span>({{ tax.rate }})</span> }</span>
        <span class="amt" [attr.data-test]="'taxValue'">{{ tax.amount | currency: currency }}</span>
      </div>
    }
    @if (delivery) {
      <div class="bk-trow">
        <span>Delivery — {{ delivery.carrier }}</span>
        <span class="amt" [attr.data-test]="'deliveryValue'">{{ delivery.amount | currency: currency }}</span>
      </div>
    }
    <div class="bk-trow final">
      <span>Total charged</span>
      <span class="amt">{{ chargedAmount | currency: currency }}</span>
    </div>
  </div>

  @if (basket.invoice) {
    <div class="bk-invoice" data-test="tx-detail-basket-invoice">
      <div class="bk-invoice-head">Invoice {{ basket.invoice.invoiceNumber }}</div>
      <div class="inv-grid">
        @if (basket.invoice.orderNumber) {
          <div class="inv-cell"><div class="k">Order number</div><div class="v" [attr.data-test]="'inv_orderNum'">{{ basket.invoice.orderNumber }}</div></div>
        }
        @if (basket.invoice.addressee) {
          <div class="inv-cell"><div class="k">Addressee</div><div class="v" [attr.data-test]="'inv_addressee'">{{ basket.invoice.addressee }}</div></div>
        }
        @if (basket.invoice.taxRegistrationNumber) {
          <div class="inv-cell"><div class="k">Tax registration</div><div class="v" [attr.data-test]="'inv_taxRegistrationNumber'">{{ basket.invoice.taxRegistrationNumber }}</div></div>
        }
        <div class="inv-cell"><div class="k">Tax status</div><div class="v" [attr.data-test]="'inv_isTaxExempt'">{{ basket.invoice.isTaxExempt ? 'Exempt' : 'Not exempt' }}</div></div>
        @if (basket.invoice.orderDate) {
          <div class="inv-cell"><div class="k">Order date</div><div class="v" [attr.data-test]="'inv_orderDate'">{{ basket.invoice.orderDate | date: 'dd/MM/yy' }}</div></div>
        }
        @if (basket.invoice.issueDate) {
          <div class="inv-cell"><div class="k">Issued</div><div class="v" [attr.data-test]="'inv_issueDate'">{{ basket.invoice.issueDate | date: 'dd/MM/yy' }}</div></div>
        }
        @if (basket.invoice.dueDate) {
          <div class="inv-cell"><div class="k">Due</div><div class="v" [attr.data-test]="'inv_dueDate'">{{ basket.invoice.dueDate | date: 'dd/MM/yy' }}</div></div>
        }
      </div>
    </div>
  }

  <details class="rawjson">
    <summary>Raw basket JSON</summary>
    <pre data-test="tx-detail-basket-raw">{{ rawBasketJson }}</pre>
  </details>
</div>
